//
// LINEAR
//
// 一定速度（イージングなし）
export const linear = (x: number): number => {
  return x;
};

//
// SINE
//
// ゆっくり始まり、滑らかに動く
export const easeInSine = (x: number): number => {
  return 1 - Math.cos((x * Math.PI) / 2);
};

// 最初は速く、ゆっくり止まる
export const easeOutSine = (x: number): number => {
  return Math.sin((x * Math.PI) / 2);
};

// 両端が滑らかで自然な加減速（jQueryのswingとほぼ同じ）
export const easeInOutSine = (x: number): number => {
  return -(Math.cos(Math.PI * x) - 1) / 2;
};

//
// QUAD
//
// ゆっくり始まる（加速） - 二次関数
export const easeInQuad = (x: number): number => {
  return x * x;
};

// 速く始まり、ゆっくり止まる（減速） - 二次関数
export const easeOutQuad = (x: number): number => {
  return 1 - (1 - x) * (1 - x);
};

// 加速→減速（滑らかなカーブ） - 二次関数
export const easeInOutQuad = (x: number): number => {
  return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
};

//
// CUBIC
//
// より強い加速 - 三次関数
export const easeInCubic = (x: number): number => {
  return x * x * x;
};

// より強い減速 - 三次関数
export const easeOutCubic = (x: number): number => {
  return 1 - Math.pow(1 - x, 3);
};

// 加速→減速（より強め） - 三次関数
export const easeInOutCubic = (x: number): number => {
  return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
};

//
// QUART
//
// さらに強い加速 - 四次関数
export const easeInQuart = (x: number): number => {
  return x * x * x * x;
};

// さらに強い減速 - 四次関数
export const easeOutQuart = (x: number): number => {
  return 1 - Math.pow(1 - x, 4);
};

// 強い加減速 - 四次関数
export const easeInOutQuart = (x: number): number => {
  return x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;
};

//
// QUINT
//
// 最も急な加速 - 五次関数
export const easeInQuint = (x: number): number => {
  return x * x * x * x * x;
};

// 最も急な減速 - 五次関数
export const easeOutQuint = (x: number): number => {
  return 1 - Math.pow(1 - x, 5);
};

// 最も強い加減速 - 五次関数
export const easeInOutQuint = (x: number): number => {
  return x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
};

//
// EXPO
//
// 序盤が急激に加速（インパクト強） - 指数関数
export const easeInExpo = (x: number): number => {
  return x === 0 ? 0 : Math.pow(2, 10 * x - 10);
};

// 終盤が急激に減速（迫力ある終わり） - 指数関数
export const easeOutExpo = (x: number): number => {
  return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
};

// 始まり・終わりが非常に急な加減速 - 指数関数
export const easeInOutExpo = (x: number): number => {
  return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2;
};

//
// CIRC
//
// 円の接線のような緩やかなカーブ（始まり） - 円形関数
export const easeInCirc = (x: number): number => {
  return 1 - Math.sqrt(1 - Math.pow(x, 2));
};

// 円の接線のような緩やかなカーブ（終わり） - 円形関数
export const easeOutCirc = (x: number): number => {
  return Math.sqrt(1 - Math.pow(x - 1, 2));
};

// 自然で美しい加減速（ゆるやかなS字） - 円形関数
export const easeInOutCirc = (x: number): number => {
  return x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
};

//
// BACK
//
// 少し逆方向に引っ張られるような始まり（跳ね返り感） - Back系
export const easeInBack = (x: number): number => {
  const c1 = 1.70158;
  const c3 = c1 + 1;
  return c3 * x * x * x - c1 * x * x;
};

// 最後に少しオーバーシュートして止まる - Back系
export const easeOutBack = (x: number): number => {
  const c1 = 1.70158;
  const c3 = c1 + 1;
  return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
};

// 入りと出の両方で反動がある - Back系
export const easeInOutBack = (x: number): number => {
  const c1 = 1.70158;
  const c2 = c1 * 1.525;
  return x < 0.5 ? (Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2)) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
};
